import { Verify } from 'iconsax-react';
import styled from 'styled-components';

export default styled(Verify)`
  color: ${({ theme }) => theme.colors.main};
  flex-shrink: 0;
  vertical-align: middle;
`;
